import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const MessageForUnknownData = styled.span`
  color: ${tokens.color.text_disabled};
  font-style: italic;
`;
